const htmlEntities = {
  "&lt;": "<",
  "&gt;": ">",
};

const convert = (inputString: string, toEntities: boolean = false) => {
  let convertedString = inputString;

  for (const [entity, char] of Object.entries(htmlEntities)) {
    const searchValue = new RegExp(toEntities ? char : entity, "g");
    const replaceValue = toEntities ? entity : char;

    convertedString = convertedString.replace(searchValue, replaceValue);
  }

  return convertedString;
};

export const convertHtmlEntitiesToAngleBrackets = (inputString: string): string => {
  return convert(inputString);
};

export const convertAngleBracketsToHtmlEntities = (inputString: string): string => {
  return convert(inputString, true);
};

export function isFirstCharUpper(str: string) {
  if (str.length === 0) {
    return false;
  }
  return str[0] === str[0].toUpperCase();
}

export const getPluralSuffix = (count: number) => (count > 1 ? "s" : "");
